const elementary = require("../vendor/elementary.js");
const axios = require("axios");
import EventsViewSwitcher from "./events-view-switcher.js";

const selector = "[data-filtered-events-list]";
let views = [];

let els = null;
let baseUrl = "";

function FilteredEventsList(siteBaseUrl) {
	// Search for carousel elements on page
	els = document.querySelectorAll(selector);

	// If there are any, continue
	if (els.length) {
		baseUrl = siteBaseUrl;
		init();
	}
}

const init = () => {
	views = [
		{
			id: "grid",
			name: gridViewText,
		},
		{
			id: "calendar",
			name: calendarViewText,
		},
	];
	if (typeof mapViewText !== "undefined") {
		views.push({
			id: "map",
			name: mapViewText,
		});
	}

	// Loop through each filters set
	[].forEach.call(els, function (item) {
		const viewType = item.dataset.filteredEventsList;

		// Listen for any change events inside filters
		item.addEventListener("filter-change", function (e) {
			console.log(e);

			// Don't automatically get events when "pick-a-date" chosen. Need to wait for selected date event.
			if (e.detail !== "pick-a-date") {
				getEvents(item);
			}
		});

		// Listen for when specific date chosen
		item.addEventListener("date-chosen", function (e) {
			console.log(e);
			item.dataset.dateChosen = true;
			getEvents(item);
		});

		// Listen for when specific date closed
		item.addEventListener("date-closed", function (e) {
			item.dataset.dateChosen = false;
			getEvents(item);
		});

		// Listen for view change click
		item.addEventListener("view-change-click", function (e) {
			console.log(e);

			// Call to load events
			switchView(item, e.detail.view);
		});
	});
};

const getFilterVals = (item) => {
	const filterVals = {};

	// Loop through all filter fields and generate object of selected values
	[].forEach.call(item.querySelectorAll("[data-filters] [data-select]"), function (filterFld) {
		// Add field name/value to object
		filterVals[filterFld.name] = filterFld.value;
	});

	// If specific date HAS been chosen
	if (item.dataset.dateChosen == "true") {
		filterVals.date = item.querySelector("[data-specific-date]").value;
	}

	console.log(filterVals);

	return filterVals;
};

const getView = (item) => {
	return item.dataset.filteredEventsList;
};

const switchView = (item, newView) => {
	// Get current view
	const currView = getView(item);

	const viewSwitchersContainer = item.querySelector(".events-view-info__action");
	if (viewSwitchersContainer) {
		console.log(viewSwitchersContainer);

		// Remove existing view switcher links
		[].forEach.call(viewSwitchersContainer.querySelectorAll("a"), function (btn) {
			btn.remove();
		});

		const currFilters = getFilterVals(item);

		// Loop through views and add switcher links
		views.forEach(function (view) {
			if (view.id !== newView) {
				// Create link element
				const linkEl = document.createElement("a");
				linkEl.href = `/whats-on?date=${currFilters.date}&category=${currFilters.category}&view=${view.id}`;
				linkEl.classList.add("swipe-link");
				linkEl.setAttribute("data-events-view-switcher-trigger", view.id);
				linkEl.innerHTML = `<span data-events-view-switcher-link-type="${view.id}">${view.name}</span>`;

				// Add to container
				viewSwitchersContainer.appendChild(linkEl);
			}
		});

		EventsViewSwitcher();

		// Update data attribute on item to show new view
		item.dataset.filteredEventsList = newView;

		getEvents(item);
	}

	// Get view data objects
	// const newViewData = views.find(function (item) {
	// 	return item.id === newView;
	// });
	// const altViewData = views.find(function (item) {
	// 	return item.id === currView;
	// });

	// // Change view text where applicable
	// item.dataset.filteredEventsList = newViewData.id;
	// item.querySelector("[data-events-view-switcher-link-type]").innerHTML = altViewData.name;

	// // Get html for this view
	// getEvents(item);
};

const updateViewSwitcherLinks = (item) => {
	const viewSwitchersContainer = item.querySelector(".events-view-info__action");
	if (viewSwitchersContainer) {
		const filterVals = getFilterVals(item);
		// Remove existing view switcher links
		[].forEach.call(viewSwitchersContainer.querySelectorAll("a"), function (btn) {
			const url = new URL(btn.href);
			const params = url.searchParams;
			params.set("date", filterVals.date);
			params.set("category", filterVals.category);
			btn.href = url.toString();
		});
	}
};

const getEvents = (item) => {
	const view = getView(item);

	updateViewSwitcherLinks(item);

	// Don't use the same loading process for map view
	if (view === "map") {
		return;
	}

	const filterVals = getFilterVals(item);

	// Call to get html
	axios
		.get(baseUrl + "actions/events-module/default/get-events", {
			params: {
				date: filterVals.date,
				category: filterVals.category,
				location: filterVals.hasOwnProperty("location") ? filterVals.location : "all",
				view: view,
			},
		})
		.then(function (response) {
			// handle success
			console.log(response);

			item.querySelector("[data-events-view-switcher-content]").innerHTML = response.data.html;
			item.querySelector("[data-events-view-switcher-total]").innerHTML = response.data.total;

			elementary();
		});

	updateUrl(filterVals, view);
};

const updateUrl = (filterVals, view) => {
	// Generate new querystring based on filter values
	let params = filterVals;
	params.view = view;

	const qs = Object.keys(params)
		.map((key) => key + "=" + params[key])
		.join("&");

	// Update url
	history.pushState("", "", window.location.href.split("?")[0] + "?" + qs);
};

export { FilteredEventsList, updateUrl, getFilterVals, getView };
